<template>
	<div class="container">
		<van-sticky>
			<navbar :title="title" />
		</van-sticky>

		<van-panel class="goods-panel" title="其他费用" :desc="other_fee_remark" v-if="$route.query.p != 1">
			<div>
				<van-cell title="数量" :value="other_fee_quantity" />
				<van-cell title="价格" :value="other_fee" />
				<van-cell  title="总价" :value="total" />
			</div>
		</van-panel>

		<van-panel
			class="goods-panel"
			v-for="(item, index) in goodsList"
			:key="index"
			:title="item.product_name"
			:desc="item.remark"
		>
			<div>
				<van-cell title="数量" :value="item.quantity" />
				<van-cell title="价格" :value="item.amount" v-if="$route.query.p != 1"/>
				<van-cell  title="总价" :value="item.amount * item.quantity" v-if="$route.query.p != 1"/>
			</div>
		</van-panel>
	</div>
</template>

<script>
import navbar from "@/components/navBar/index";
import { post } from "@/api/order";
import { Toast } from "vant";

export default {
	components: {
		navbar
	},
	data() {
		return {
			title: "商品详情",
			activeName: "index",
			order_id: this.$route.query.id,
			goodsList: {},
			other_fee: "",
			other_fee_quantity: "",
			other_fee_remark: "",
			total: ""
		};
	},
	mounted() {
		this.getGoods();
	},
	methods: {
		getGoods() {
			post({
				requestType: "sales_order_product_details",
				order_id: this.order_id
			})
				.then(res => {
					console.log(res);
					this.other_fee = res.obj.other_fee;
					this.other_fee_quantity = res.obj.other_fee_quantity;
					this.other_fee_remark = res.obj.other_fee_remark;
					this.total = res.obj.total;
					this.goodsList = JSON.parse(res.obj.product_list);
				})
				.catch(err => {
					console.log(err);
					return Toast.fail("数据异常");
				});
		}
	}
};
</script>

<style lang="scss" scoped>
.goods-panel {
	margin-top: 10px;
}
</style>
